import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import { useCallback, useEffect, useState } from 'react';
import styled from '@xstyled/styled-components';
import { Radio, Form } from 'antd';
import { TextLinkButton, TextOptionInput } from '@lib/common';
import { BaseQuestionEdit } from './base-question-edit.component';
import { useForm } from 'antd/lib/form/Form';
import { styleVariables } from '@lib/common';
import { PlusCircleOutlined } from '@ant-design/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AnswerListField = styled(Form)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-radio-wrapper {\n    margin-right: 0;\n  }\n"])));
var AnswerItem = styled(Radio)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  span.ant-radio + * {\n    flex: 1;\n    height: auto;\n    padding-right: 0;\n  }\n  .ant-radio-inner::after {\n    background-color: ", ";\n  }\n  .ant-radio-checked .ant-radio-inner {\n    border-color: ", ";\n  }\n  .ant-input-affix-wrapper {\n    border-radius: 4px !important;\n    border-color: ", ";\n  }\n"])), styleVariables.colors.blue4, styleVariables.colors.blue4, styleVariables.colors.gray8);
var AnswerGroup = styled(Radio.Group)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var ButtonAddMoreAnswer = styled(TextLinkButton)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 500;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 0px;\n  margin-bottom: 24px;\n"])), styleVariables.colors.blue4);
var QuestionContentTitle = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 600;\n"])));
var AddingIcon = styled(PlusCircleOutlined)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-right: 10px;\n"])));
var fieldType = {
  id: 'id',
  description: 'description',
  type: 'type'
};
export var SingleChoiceQuestionEdit = function SingleChoiceQuestionEdit(props) {
  var question = props.question,
      index = props.index,
      onDeleteQuestion = props.onDeleteQuestion,
      onUpdateQuestion = props.onUpdateQuestion,
      onUpdateCorrectAnswer = props.onUpdateCorrectAnswer,
      onUpdateAnswer = props.onUpdateAnswer,
      onDeleteAnswer = props.onDeleteAnswer,
      onResetDeleteAnswer = props.onResetDeleteAnswer,
      deleteAnswerStatus = props.deleteAnswerStatus,
      onCreateAnswer = props.onCreateAnswer,
      createAnswerStatus = props.createAnswerStatus,
      onResetCreateAnswer = props.onResetCreateAnswer,
      onUpdateTypeQuestion = props.onUpdateTypeQuestion;

  var _useForm = useForm(),
      _useForm2 = _slicedToArray(_useForm, 1),
      form = _useForm2[0];

  var getFieldValue = form.getFieldValue,
      setFieldsValue = form.setFieldsValue;

  var _useState = useState(false),
      mathEditorModalVisible = _useState[0],
      setMathEditorModalVisible = _useState[1];

  var onUpdateForAnswer = useCallback(function (index, field, value) {
    if (field === fieldType.id) {
      onUpdateCorrectAnswer(index, field, value);
    } else {
      onUpdateAnswer(index, field, value);
    }
  }, [onUpdateAnswer, onUpdateCorrectAnswer]);
  var onUpdateForQuestion = useCallback(function (field, value) {
    var questionId = getFieldValue(fieldType.id);

    if (field === fieldType.type) {
      onUpdateTypeQuestion(questionId, value);
    } else {
      onUpdateQuestion(questionId, field, value);
    }
  }, [getFieldValue, onUpdateQuestion, onUpdateTypeQuestion]);
  var onFieldsChange = useCallback(function (e) {
    var _e = _slicedToArray(e, 1),
        infoChange = _e[0];

    if (!infoChange) return;
    var name = infoChange.name,
        value = infoChange.value;

    if (name.length <= 1) {
      var _name = _slicedToArray(name, 1),
          _field = _name[0];

      return onUpdateForQuestion(_field, value);
    } else {
      var _name2 = _slicedToArray(name, 3),
          _index = _name2[1],
          _field2 = _name2[2];

      return onUpdateForAnswer(_index, _field2, value);
    }
  }, [onUpdateForAnswer, onUpdateForQuestion]);
  var onHandleMathEditorModal = useCallback(function (index) {
    setMathEditorModalVisible(!mathEditorModalVisible);
    if (index === undefined) return;
  }, [mathEditorModalVisible]);
  useEffect(function () {
    if (deleteAnswerStatus || createAnswerStatus) {
      setFieldsValue(question.toJsonObject());
      deleteAnswerStatus && onResetDeleteAnswer();
      createAnswerStatus && onResetCreateAnswer();
    }
  }, [createAnswerStatus, deleteAnswerStatus, onResetCreateAnswer, onResetDeleteAnswer, question, setFieldsValue]);
  return /*#__PURE__*/_jsx(Form, {
    form: form,
    name: "question-single-choice-form",
    initialValues: question.toJsonObject(),
    onFieldsChange: onFieldsChange,
    children: /*#__PURE__*/_jsxs(BaseQuestionEdit, {
      index: index,
      onDeleteQuestion: onDeleteQuestion,
      type: question.type,
      children: [/*#__PURE__*/_jsx(QuestionContentTitle, {
        children: "Ch\u1ECDn \u0111\xE1p \xE1n \u0111\xFAng "
      }), /*#__PURE__*/_jsx(AnswerGroup, {
        defaultValue: question.correctAnswers[0].answerId,
        children: /*#__PURE__*/_jsx(AnswerListField.List, {
          name: "answers",
          children: function children(fields) {
            return fields.map(function (field) {
              return /*#__PURE__*/_jsx(AnswerListField.Item, {
                name: [field.name, 'id'],
                children: /*#__PURE__*/_jsx(AnswerItem, {
                  children: /*#__PURE__*/_jsx(AnswerListField.Item, {
                    name: [field.name, 'description'],
                    children: /*#__PURE__*/_jsx(TextOptionInput, {
                      onDelete: function onDelete() {
                        return onDeleteAnswer(field.key);
                      },
                      onOpenMathEditorModal: function onOpenMathEditorModal() {
                        return onHandleMathEditorModal(field.key);
                      },
                      hasImage: false,
                      onShowingUploadImageModal: function onShowingUploadImageModal() {
                        throw new Error('Function not implemented.');
                      }
                    })
                  })
                })
              }, field.key);
            });
          }
        })
      }), /*#__PURE__*/_jsxs(ButtonAddMoreAnswer, {
        onClick: onCreateAnswer,
        children: [/*#__PURE__*/_jsx(AddingIcon, {}), "Th\xEAm \u0111\xE1p \xE1n"]
      })]
    })
  });
};